import { AppPermissions } from 'constants/permissions';

export const permissions = {
  viewTransaction: [AppPermissions.change_payment, AppPermissions.add_payment],
  changeInvoice: [AppPermissions.change_invoice],
  viewInvoice: [AppPermissions.view_invoice],
  viewProformaInvoice: [AppPermissions.view_proformainvoice],
  changeProformaInvoice: [AppPermissions.change_proformainvoice],
};
